// @ts-nocheck
/* eslint-disable */

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.ProgressBarColorMapping = exports.ProgressBar = void 0;

var _react = _interopRequireDefault(require('react'));

var _propTypes = _interopRequireDefault(require('prop-types'));

var _styledComponents = require('styled-components');

var _ProgressBar = require('./ProgressBar.styled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var ProgressBar = function ProgressBar(props) {
  var value = props.value,
    theme = props.theme,
    colorMapping = props.colorMapping,
    maxValue = props.maxValue,
    children = props.children,
    rest = _objectWithoutProperties(props, ['value', 'theme', 'colorMapping', 'maxValue', 'children']);

  var barPercentage = Math.round((value / maxValue) * 100);

  var getBackgroundColor = function getBackgroundColor() {
    var colorValue = colorMapping.length > 0 ? colorMapping : theme.graphs.barGauge.colorMapping;
    var colorRange = colorValue.find(function (mappingObject) {
      return barPercentage >= mappingObject.min && barPercentage <= mappingObject.max;
    });
    return colorRange ? colorRange.color : '';
  };

  return _react.default.createElement(
    _react.default.Fragment,
    null,
    _react.default.createElement(
      _ProgressBar.StyledProgressBarContainer,
      rest,
      _react.default.createElement(
        _ProgressBar.StyledBarIndicator,
        _extends(
          {
            value: barPercentage,
            backgroundColor: getBackgroundColor()
          },
          rest
        )
      )
    ),
    _react.default.createElement(_ProgressBar.StyledLabelsContainer, rest, children)
  );
};

var ProgressBarWrapper = (0, _styledComponents.withTheme)(ProgressBar);
exports.ProgressBar = ProgressBarWrapper;

var ProgressBarColorMapping = function ProgressBarColorMapping() {
  ProgressBarColorMapping.propTypes = {
    min: _propTypes.default.number.isRequired,
    max: _propTypes.default.number.isRequired,
    color: _propTypes.default.string.isRequired
  };
};

exports.ProgressBarColorMapping = ProgressBarColorMapping;
ProgressBar.defaultProps = {
  maxValue: 100,
  containerColor: '',
  colorMapping: [],
  children: undefined,
  theme: {},
  labelPaddingTop: '',
  radius: '',
  height: '',
  justifyLabels: 'center'
};
ProgressBar.propTypes = {
  value: _propTypes.default.number.isRequired,
  maxValue: _propTypes.default.number,
  containerColor: _propTypes.default.string,
  children: _propTypes.default.node,
  colorMapping: _propTypes.default.arrayOf(ProgressBarColorMapping),
  theme: _propTypes.default.any,
  labelPaddingTop: _propTypes.default.string,
  radius: _propTypes.default.string,
  height: _propTypes.default.string,
  justifyLabels: _propTypes.default.oneOf([
    'flex-start',
    'flex-end',
    'center',
    'space-between',
    'space-around',
    'initial',
    'inherit'
  ])
};
